import axios from "axios";
import { ManagerCounters } from "../../../types/model/stats";
import { SessionStore } from "../../../types/store/SessionStore";
import { newAbortSignal } from "../../../utils";

const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/app`;

export const getManagerCounters = async (): Promise<ManagerCounters> => {
  const session: SessionStore | undefined = JSON.parse(
    localStorage.getItem("session") || "{}",
  );

  const finalURL = BASE_URL + "/manager/stats";

  return await axios
    .get<ManagerCounters>(finalURL, {
      headers: {
        "content-type": "application/json",
        "x-access-token": session?.accessToken,
      },
      timeout: Number.parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`),
      signal:
        AbortSignal.timeout === undefined
          ? newAbortSignal(
              Number.parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`),
            )
          : AbortSignal.timeout(
              Number.parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`),
            ),
    })
    .then((response) => response.data);
};
